"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddonSelectModal = void 0;
const react_1 = __importDefault(require("react"));
const Card_1 = __importDefault(require("react-bootstrap/Card"));
const ListGroup_1 = __importDefault(require("react-bootstrap/ListGroup"));
const Modal_1 = __importDefault(require("react-bootstrap/Modal"));
const AddonPriceTag_1 = require("../addon-price-tag/AddonPriceTag");
require("./AddonSelectModal.scss");
const AddonSelectModal = (props) => {
    var _a;
    return (react_1.default.createElement(Modal_1.default, { className: "addon-select-modal " + ((_a = props.className) !== null && _a !== void 0 ? _a : ""), show: true, onHide: props.onClose, animation: false, centered: true },
        react_1.default.createElement(Modal_1.default.Header, { closeButton: true },
            react_1.default.createElement(Modal_1.default.Title, null,
                props.type,
                " hinzuf\u00FCgen")),
        react_1.default.createElement(Modal_1.default.Body, null,
            react_1.default.createElement(Card_1.default, null,
                react_1.default.createElement(ListGroup_1.default, { variant: "flush" },
                    props.configAddons.map((configAddon) => {
                        return (react_1.default.createElement(ListGroup_1.default.Item, { key: configAddon.title, className: "media d-flex", action: true, onClick: () => props.onAddonSelected(configAddon) },
                            react_1.default.createElement("div", { className: "media-img", style: {
                                    backgroundImage: `url(${configAddon.getImageUrls()[0]})`,
                                } }),
                            react_1.default.createElement("div", { className: "media-body" },
                                react_1.default.createElement("h5", { className: "mt-0 mb-1" }, configAddon.title),
                                react_1.default.createElement(AddonPriceTag_1.AddonPriceTag, { priceModel: configAddon.priceModel, unitSingular: configAddon.units.singular, maxQuantity: configAddon.maxQuantity }))));
                    }),
                    react_1.default.createElement(ListGroup_1.default.Item, { key: "custom", action: true, onClick: props.onCustomAddonSelected },
                        react_1.default.createElement("div", { className: "media-body" },
                            react_1.default.createElement("h5", { className: "mt-0 mb-1" }, "Benutzerdefiniert"),
                            "Kategorie ",
                            react_1.default.createElement("strong", null, props.type))))))));
};
exports.AddonSelectModal = AddonSelectModal;
